import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('MainStories').create(({ theme }) => ({
  root: {
    width: '100vw',
    height: '100vh',
    background: 'black',
    display: 'flex',
    paddingBottom: '32px',
    flexDirection: 'column',
    alignItems: 'center',
    fontFamily: 'SF Pro Display',
  },

  content: {
    top: '64px',
    position: 'relative',
    zIndex: 5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  glow1: {
    position: 'absolute',
    zIndex: 2,
    top: '-10%',
  },
  glow2: {
    position: 'absolute',
    zIndex: 2,
    bottom: '0%',
  },

  gamedBlurred: {
    width: '110px',
    position: 'absolute',
    bottom: '32px',
  },

  backgroundPlayerInfoCard: {
    position: 'absolute',
    top: '32px',
    transform: 'rotate(15deg)',
    opacity: '0.3',
  },

  playerInfoCard: {
    zIndex: 5,
    position: 'relative',
    top: '0%',
    width: '95vw',
    alignSelf: 'center',
    alignItems: 'center',
    display: 'flex',
    padding: '20px',
    gap: '15px',
    borderRadius: '56px',
    minHeight: '122px',

  },

  userInfo: {
    display: 'flex',
    width: '75vw',
    gap: '12px',
  },

  userIdWrapper: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  },

  userIdAndUsernameWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },

  userIdText: {
    color: '#A5D6FF',
    fontSize: '13px',
    fontWeight: 450,
    lineHeight: '18px',
  },

  usernameText: {
    color: '#4C9CFE',
    textShadow: '0px 2px 2px #121F58, 0px -1px 2px #121F58',
    fontSize: '18px',
    fontWeight: 600,
    textTransform: 'uppercase',
  },

  userValuesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },

  gigiBalanceWrapper: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },

  gigiValueText: {
    fontWeight: 600,
    fontSize: '18px',
    color: theme.colors.text.primary,
    lineHeight: '18px',
  },

  gigiUnitText: {
    fontWeight: 400,
    fontSize: '14px',
    color: '#A5D6FF',
  },

  hole: {
    position: 'absolute',
    right: '5%',
  },

  userPfp: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '72px',
    overflow: 'hidden',
    borderRadius: '24px',
    border: '3px solid transparent',

    img: {
      width: '100%',
      borderRadius: '24px',
    },
  },

  connectedPlatformsWrapper: {
    width: '90vw',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  connectedPlatformsText: {
    color: theme.colors.text.secondary,
    fontSize: theme.sizes.texts.fontSize.s,
    fontWeight: 350,
    lineHeight: '14px',
  },

  platformImageWrapper: {
    display: 'flex',
    gap: '8px',
  },

  platformImg: {
    width: '22px',
    alignSelf: 'center',

    '&[data-isconnected="false"]': {
      opacity: '0.3',
    },
  },

  totalPlaytimeWrapper: {
    width: '90vw',
    height: '77px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    borderRadius: '16px',
    border: '1px solid',
    borderColor: theme.colors.borders.default,
    // background: theme.colors.background.primary,
    background: 'rgba(255, 255, 255, 0.10)',
    alignItems: 'center',
    justifyContent: 'center',
  },

  statTitle: {
    color: theme.colors.text.secondary,
    fontSize: theme.sizes.texts.fontSize.m,
    fontWeight: 350,
  },

  statValue: {

    color: theme.colors.text.primary,
    fontFamily: 'Space Grotesk, Inter',
    fontWeight: 400,
    fontSize: '18px',
  },

  gigiAndGeneralStatsWrapper: {
    display: 'flex',
    gap: '12px',
    width: '90vw',
    justifyContent: 'space-between',
  },

  statsWrapper: {
    width: '50%',
    gap: '12px',
    marginTop: '12px',
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 14px',
    borderRadius: '16px',
    border: '1px solid',
    borderColor: theme.colors.borders.default,
    // background: theme.colors.background.primary,
    background: 'rgba(255, 255, 255, 0.10)',
  },

  statContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
}))
